'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = require('preact-fela');

var _ChevronIcon = require('../../Icon/ChevronIcon');

var _ChevronIcon2 = _interopRequireDefault(_ChevronIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdownButtonIcon = function dropdownButtonIcon(_ref) {
  var open = _ref.open,
      inside = _ref.inside,
      color = _ref.color;
  return {
    color: inside ? color : 'currentColor',
    marginLeft: inside ? 'auto' : '8px',
    transition: 'transform 0.2s ease-in-out',
    transform: open ? 'rotate(-180deg)' : null
  };
};

exports.default = (0, _preactFela.createComponent)(dropdownButtonIcon, _ChevronIcon2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Dropdown/DropdownButtonIcon.js
// module id = 59
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38